"use client";

import { ShortcodeRenderer } from "@/components/ShortcodeRenderer";

interface CustomTextSectionProps {
  tenant: {
    primaryColor: string;
  };
  title?: string | null;
  description?: string | null;
}

/**
 * Custom Text Section Component for Tenant Pages
 *
 * Displays a customizable text section with optional title and HTML content.
 * The description supports HTML that is sanitized before rendering.
 */
export function CustomTextSection({ title, description }: CustomTextSectionProps) {
  if (!title && !description) {
    return null;
  }

  return (
    <div className="max-w-4xl mx-auto mt-16">
      <div
        className="rounded-lg shadow-md p-8"
        style={{ backgroundColor: 'var(--theme-bg, #FFFFFF)' }}
      >
        {title && (
          <h2
            className="text-2xl font-bold mb-6 text-center"
            style={{ color: 'var(--theme-text, #111827)' }}
          >
            {title}
          </h2>
        )}
        {description && (
          <ShortcodeRenderer
            content={description}
            className="prose prose-lg max-w-none [&>*]:mb-4 [&>*:last-child]:mb-0"
          />
        )}
      </div>
    </div>
  );
}
